export enum WaitingListEventType {
  ITEM_CREATED = "item_created",
  EMAIL_SENT = "email_sent",
}
